import suelos from "@/assets/ia-evidencias/suelos-hormigon-madrid.png.asset.json";
import hostelearte from "@/assets/ia-evidencias/hostelearte.png.asset.json";
import itv from "@/assets/ia-evidencias/itv-maquinas-hielo.png.asset.json";
import barbers from "@/assets/ia-evidencias/barbers-roldan.png.asset.json";

/** Capturas reales autorizadas por Ángel Ruz (5 nov 2026). Una aparición puntual, no una posición estable. */
export const aiEvidences = [
  {
    id: "suelos-hormigon-madrid",
    kind: "Proyecto propio · servicio local",
    name: "Suelos Hormigón Madrid",
    summary: "La respuesta de IA de Google la cita entre las empresas especializadas para pedir presupuesto de suelos de hormigón en Madrid.",
    query: "suelo de hormigón Madrid",
    alt: "Respuesta de IA de Google que menciona Suelos Hormigón Madrid como empresa especializada",
    image: suelos, width: 786, height: 382,
  },
  {
    id: "hostelearte",
    kind: "Cliente · maquinaria de hostelería",
    name: "Hostelearte",
    summary: "Aparece en el mapa y en la lista de proveedores destacados de la Comunidad de Madrid, con su ficha de Google.",
    query: "proveedores de equipamiento para hostelería en Madrid",
    alt: "Respuesta de IA de Google con mapa que incluye Hostelearte en Puente de Vallecas",
    image: hostelearte, width: 1444, height: 681,
  },
  {
    id: "itv-maquinas-hielo",
    kind: "Cliente · ecommerce",
    name: "ITV Máquinas de Hielo",
    summary: "La IA de Google la presenta como canal directo para comprar la gama Orion, enlazando a su web.",
    query: "comprar maquina de hielo orion itv",
    alt: "Respuesta de IA de Google que recomienda itvmaquinasdehielo.es como canal directo de compra",
    image: itv, width: 1360, height: 705,
  },
  {
    id: "barbers-roldan",
    kind: "Cliente · negocio local",
    name: "Barber's Roldán",
    summary: "Primera opción listada para corte de caballero en Numancia de la Sagra, con su web como primera fuente.",
    query: "peluqueria caballeros numancia de la sagra",
    alt: "Respuesta de IA de Google que lista Barber's Roldán en Numancia de la Sagra",
    image: barbers, width: 1303, height: 766,
  },
] as const;

export const integrationSteps = [
  { title: "Diagnóstico SEO y de IA", text: "Revisamos cómo aparece tu empresa en Google, Google Maps y una muestra de consultas en asistentes de IA, con fecha y fuentes visibles." },
  { title: "Base técnica y datos coherentes", text: "Web rastreable, datos estructurados correctos y la misma información de empresa en web, ficha y directorios." },
  { title: "Contenido que responde", text: "Páginas que contestan preguntas reales de tus clientes. La IA acelera la producción; el equipo revisa exactitud y utilidad." },
  { title: "Ficha local y reputación", text: "Google Business Profile completo, categorías, servicios y reseñas gestionadas de forma ética." },
  { title: "Menciones y autoridad", text: "Presencia en fuentes del sector que los buscadores y asistentes consultan." },
  { title: "Observación y ajustes", text: "Repetimos las consultas definidas, documentamos cambios y priorizamos las siguientes tareas." },
];

export const integrationFaqs = [
  { question: "¿Podéis garantizar que la IA recomiende mi empresa?", answer: "No. Nadie puede garantizarlo. Trabajamos las señales que usan los buscadores y asistentes, y medimos las apariciones en consultas definidas." },
  { question: "¿Es lo mismo que el SEO local?", answer: "No. El SEO local trabaja Google Maps y la ficha de empresa; la integración de IA añade las respuestas generativas. Se combinan cuando el diagnóstico lo justifica." },
  { question: "¿Qué compromiso mínimo tiene?", answer: "El SEO local tiene un mínimo de 3 meses y GEO de 6 meses. La continuidad posterior es opcional y a convenir." },
  { question: "¿Necesito un archivo especial o schema para la IA?", answer: "Google no exige requisitos especiales para sus funciones de IA. La base es un SEO correcto, contenido útil y datos coherentes." },
];
